"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var numberLookupMap_1 = __importDefault(require("./numberLookupMap"));
// get the closest vulgar fraction from a decimal
var getClosestLookupNumber = function (value) {
    var closest = 0;
    var difference = 1;
    Object.keys(numberLookupMap_1.default).forEach(function (key) {
        var decimal = parseFloat(key);
        var newDifference = Math.abs(value - decimal);
        if (newDifference < difference) {
            difference = newDifference;
            closest = decimal;
        }
    });
    return closest;
};
exports.default = getClosestLookupNumber;
